import { lazy } from 'react';

const Transition = lazy(() => import('@headlessui/react').then((module) => ({ default: module.Transition })));
const Loading = lazy(() => import('@wayste/sour-ui').then((module) => ({ default: module.Loading })));

const Loader = ({ isLoading, loadingMsg }: { isLoading: boolean; loadingMsg?: string }) => {
    return (
        <Transition
            show={isLoading}
            enter="transition-opacity duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
        >
            <div
                className={`backdrop-blur-xs fixed inset-0 z-50 flex items-center justify-center ${
                    isLoading ? 'opacity-100' : 'opacity-0'
                } transition-opacity duration-300`}
            >
                <div className="absolute inset-0 bg-gray-400 bg-opacity-20"></div>
                <div className="relative z-10 flex scale-100 transform flex-col items-center justify-center space-y-4 transition-transform delay-75 duration-300">
                    <Loading size="h-12 w-12" aria-label="Loading" />
                    <p className="text-lg font-bold text-gray-700">{loadingMsg || 'Loading...'}</p>
                </div>
            </div>
        </Transition>
    );
};

export default Loader;
